/**
 * App Analytics MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { APP_ANALYTICS_QUERY_KEY, fetchAppAnalyticsFromApi } from "./appAnalyticsQueryApi";

export const appAnalyticsQueryClient = makeMv2QueryClient();

export function prefetchAppAnalytics(period) {
  if (!period) return Promise.resolve();
  return appAnalyticsQueryClient.prefetchQuery({
    queryKey: [APP_ANALYTICS_QUERY_KEY, period],
    queryFn: ({ signal }) => fetchAppAnalyticsFromApi(period, signal),
  });
}
